import React from 'react'
import { Modal, Button, Icon, List, Image, Divider, Grid } from 'semantic-ui-react'
import contentImage from '../../../../../images/svg/noti-content.svg'
import convertIcon from '../../../../../helpers/convert-Icon';
import momentDateAndTime from '../../../../../helpers/momentDateAndTime'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toastr } from 'react-redux-toastr';
import defaultLogo from '../../../../../images/logo/logo-128.png'
var moment = require('moment');
class ContentDetail extends React.Component {

    close = () => {
        this.props.openDialog(false);
    }

    openURL = (url) => {
        let redirectUrl = url.indexOf('://') === -1 ? 'http://' + url : url;
        window.open(redirectUrl, '_blank');
    }

    render() {
        let selectedContent = this.props.content ? this.props.content : {}
        return (
            <Modal
                className="EditModalCard basicModal"
                open={this.props.isOpen}
                closeOnEscape={true}
                closeOnDimmerClick={false}
                size="tiny"
                closeIcon
                onClose={this.close}
            >
                <Modal.Header>
                    Content Details
                </Modal.Header>
                <Modal.Content className="pad_0" scrolling>
                    <div style={{ padding: "10px 20px" }}>
                        <Grid columns={2}>
                            <Grid.Row className="pad_0">
                                <Grid.Column style={{ padding: "0 20px 0 0" }}>
                                    <List size="small" >
                                        <List.Item>
                                            <Image
                                                avatar
                                                style={{ objectFit: "cover" }}
                                                src={selectedContent.accountId && selectedContent.accountId.logo ? selectedContent.accountId.logo : defaultLogo}
                                            />
                                            {/* <Image
                                                style={{
                                                    height: '26px',
                                                    margin: '0 8px 0 0 !important'
                                                }}
                                                src={selectedContent.accountId && selectedContent.accountId.logo}
                                            /> */}
                                            <List.Content>
                                                <span className="">Account </span>
                                                <List.Header>{selectedContent.accountId && selectedContent.accountId.name}</List.Header>
                                            </List.Content>
                                        </List.Item>
                                    </List>
                                </Grid.Column>
                                <Grid.Column style={{ padding: "0 20px 0 0" }}>
                                    <List size="small" >
                                        <List.Item>
                                            <Icon
                                                name="world"
                                                className="c-image-icon f_18 c-image-ws-icon"
                                            />
                                            <List.Content>
                                                <span className="">Workspace</span>
                                                <List.Header>
                                                    {selectedContent.organizationId && selectedContent.organizationId.name}
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>
                                    </List>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </div>

                    <Divider className="mar_0" />
                    <div style={{ padding: "10px 20px" }}>
                        <Grid columns={2}>
                            <Grid.Row className="pad_0">
                                <Grid.Column style={{ padding: "0 20px 0 0" }}>
                                    <List size="small" >
                                        <List.Item>
                                            <Image
                                                avatar
                                                src={selectedContent.author && selectedContent.author.profilePic}
                                            />
                                            <List.Content>
                                                <span className="">Content Owner</span>
                                                <List.Header>
                                                    {selectedContent.author && selectedContent.author.firstName}&nbsp;
                                                    {selectedContent.author && selectedContent.author.lastName}
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>
                                    </List>
                                </Grid.Column>
                                <Grid.Column style={{ padding: "0 20px 0 0" }}>
                                    <List size="small" >
                                        <List.Item>
                                            <List.Content>
                                                <span className="">Publishing Level</span>
                                                <List.Header >
                                                    <span className="clr-green">{selectedContent.scope === "Public" ? "Public Library" : "Workspace Library"}</span>
                                                </List.Header>
                                            </List.Content>
                                        </List.Item>
                                    </List>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>

                    </div>
                    <Divider className="mar_0" />
                    <div style={{ padding: "10px 20px" }}>
                        <List size="small">
                            <List.Item>
                                <Image className="c-image-icon" src={contentImage} />
                                <List.Content className="c-image-icon-content" >
                                    <span className="">Content Name</span>
                                    <List.Header>{selectedContent.name}</List.Header>
                                </List.Content>
                            </List.Item>
                        </List>
                    </div>
                    <Divider className="mar_0" />
                    <div style={{ padding: "10px 20px" }}>
                        <List size="small">
                            <List.Item>
                                <Icon
                                    name="calendar alternate outline"
                                    className="c-image-icon f_16 "
                                    style={{ color: "#bdccd4" }} />
                                <List.Content className="c-image-icon-content" >
                                    <span className="">Created On</span>
                                    <List.Header>{momentDateAndTime(selectedContent.createdAt)}</List.Header>
                                </List.Content>
                            </List.Item>
                        </List>
                    </div>
                    <Divider className="mar_0" />
                    <div style={{ padding: "10px 20px" }}>
                        <List size="small">
                            <List.Item>
                                <Icon
                                    name="file alternate"
                                    className="c-image-icon f_16 "
                                    style={{ color: "#bdccd4" }} />
                                <List.Content className="c-image-icon-content" >
                                    <span className="">Category</span>
                                    <List.Header>
                                        {selectedContent.baseCategory && selectedContent.baseCategory.name}
                                        <Icon name="chevron right" />
                                        {selectedContent.category && selectedContent.category.name}
                                        <Icon name="chevron right" />
                                        {selectedContent.subCategory && selectedContent.subCategory.name}
                                    </List.Header>
                                </List.Content>
                            </List.Item>
                        </List>
                    </div>
                    <Divider className="mar_0" />
                    <div style={{ padding: "10px 20px" }}>
                        <List size="small">
                            <List.Item>
                                <Icon
                                    name={convertIcon(selectedContent.type)}
                                    className="c-image-icon f_16 clr-blue cursor-pointer"
                                    style={{ color: "#bdccd4" }}
                                    onClick={e => this.openURL(selectedContent.contentpath)} />
                                <List.Content className="c-image-icon-content" >
                                    <List.Header>
                                        <CopyToClipboard
                                            className="clr-blue cursor-pointer contentURLLink"
                                            text={selectedContent.contentpath}
                                            onCopy={() => toastr.success('Message', 'Content URL is copied to clipboard')}>
                                            <span>Copy Link</span>
                                        </CopyToClipboard>
                                    </List.Header>
                                </List.Content>
                            </List.Item>
                        </List>
                    </div>
                    <Divider className="mar_0" />
                    <div style={{ padding: "10px 20px" }}>
                        <List size="small">
                            <List.Item>
                                <Icon
                                    name="user circle outline"
                                    className="c-image-icon f_16 "
                                    style={{ color: "#bdccd4" }} />
                                <List.Content className="c-image-icon-content" >
                                    <span className="">Content Author</span>
                                    <List.Header>{selectedContent.contentAuthor ? selectedContent.contentAuthor : "NA"}</List.Header>
                                </List.Content>
                            </List.Item>
                        </List>
                    </div>

                    <Divider className="mar_0" />
                    <div style={{ padding: "10px 20px" }}>
                        <List size="small">
                            <List.Item>
                                <Icon
                                    name="file alternate outline"
                                    className="c-image-icon f_16 "
                                    style={{ color: "#bdccd4" }} />
                                <List.Content className="c-image-icon-content" >
                                    <span className="">Description</span>
                                    <List.Header >
                                        {selectedContent.description ?
                                            <div dangerouslySetInnerHTML={{ __html: selectedContent.description }} /> :
                                            <span>No Description Added</span>
                                        }
                                    </List.Header>
                                </List.Content>
                            </List.Item>
                        </List>
                    </div>

                </Modal.Content>
                <Modal.Actions>
                    <Button
                        content="Got it"
                        className="button-submit"
                        onClick={this.close}
                    />
                </Modal.Actions>
            </Modal >

        )
    }
}
export default ContentDetail;